import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from "../../components/ui/table";
import { Badge } from "../../components/ui/badge";
import { Input } from "../../components/ui/input";
import { AlertTriangle } from "lucide-react";
import { toast } from "sonner";

export default function AdminInventory() {
  const [rows, setRows] = useState([]);
  const [deltas, setDeltas] = useState({});
  const load = () => api.get("/admin/inventory").then(r=>setRows(r.data));
  useEffect(() => { load(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, []);

  const adjust = async (row) => {
    const key = row.variant_sku;
    const delta = Number(deltas[key] || 0);
    if (!delta) return;
    await api.post("/admin/inventory/adjust", { product_id: row.product_id, variant_sku: row.variant_sku, delta, reason: delta>0?"restock":"adjustment" });
    toast.success(`Adjusted ${row.product_name} ${row.variant_label} by ${delta}`);
    setDeltas({...deltas, [key]: ""}); load();
  };

  const lowStock = rows.filter(r => r.reorder_recommended);

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-3xl font-outfit font-bold">Inventory</h1>
        <div className="text-sm text-stone-500">{rows.length} SKUs · {lowStock.length} need restocking</div>
      </div>

      {lowStock.length > 0 && (
        <div className="bg-[#993322]/5 border border-[#993322]/30 rounded-lg p-4 mb-4 flex items-start gap-3">
          <AlertTriangle className="w-5 h-5 text-[#993322] shrink-0 mt-0.5"/>
          <div className="text-sm">
            <div className="font-semibold text-[#993322]">Restock recommended</div>
            <div className="text-stone-600">{lowStock.length} SKUs are at or below their low-stock threshold. Prioritize items with fewest days of stock left.</div>
          </div>
        </div>
      )}

      <div className="bg-white border border-stone-200 rounded-lg overflow-hidden">
        <Table>
          <TableHeader><TableRow>
            <TableHead>Product</TableHead><TableHead>Variant</TableHead>
            <TableHead>Stock</TableHead><TableHead>Threshold</TableHead>
            <TableHead>Avg daily</TableHead><TableHead>Days left</TableHead>
            <TableHead>Status</TableHead><TableHead>Adjust</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {rows.map(r => (
              <TableRow key={`${r.product_id}-${r.variant_sku}`} data-testid={`inv-${r.variant_sku}`}>
                <TableCell className="font-medium">{r.product_name}</TableCell>
                <TableCell>{r.variant_label}</TableCell>
                <TableCell><span className={r.stock <= r.low_stock_threshold ? "text-[#993322] font-semibold" : ""}>{r.stock}</span></TableCell>
                <TableCell className="text-xs text-stone-500">{r.low_stock_threshold}</TableCell>
                <TableCell className="text-xs">{r.avg_daily_sales}</TableCell>
                <TableCell className="text-xs">{r.estimated_days_left > 999 ? "∞" : r.estimated_days_left + "d"}</TableCell>
                <TableCell>{r.reorder_recommended ? <Badge variant="destructive">Restock</Badge> : <Badge variant="secondary">OK</Badge>}</TableCell>
                <TableCell><div className="flex gap-1">
                  <Input type="number" value={deltas[r.variant_sku]||""} onChange={e=>setDeltas({...deltas, [r.variant_sku]:e.target.value})} className="w-20 h-8" placeholder="±"/>
                  <button onClick={()=>adjust(r)} data-testid={`adjust-${r.variant_sku}`} className="text-xs bg-[#3B2F2F] text-white rounded px-2">Apply</button>
                </div></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
